import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { EntregaProjeto } from '../../models/entregas-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { EntregasProjetoService } from '../../services/entregas-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-entrega-projeto-edit',
  templateUrl: './detalhe-entrega-projeto-edit.component.html',
  styleUrls: ['./detalhe-entrega-projeto-edit.component.scss']
})
export class DetalheEntregaProjetoEditComponent extends BaseFormComponent<EntregaProjeto> implements OnInit {

  idProjeto: number;
  entrega: EntregaProjeto;
  cloneEntrega: boolean;
  infoProjeto: ProjetoCadastro;
  actionLabel: string = 'Nova';
  list: any;
  listUsuario: any[];
  listOrgaos: any[];
  simNaoList: any[] = [
    { id: "0", label: "Não" },
    { id: "1", label: "Sim" },
  ];
  audit: AtualizacoesAudit;
  permissions: ProjetoPermission;

  constructor(
    private myService: EntregasProjetoService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;

      this.listUsuario = this.activatedRoute.snapshot.data['listUsuario'];
      this.list = this.activatedRoute.snapshot.data['list'];
      this.list.process_list = Object.values(this.list.process_list);
      this.listOrgaos = this.list['orgaos'];
      this.cloneEntrega = this.activatedRoute.snapshot.data['clone'];
      this.initForm();
    });
    // if( !this.permissions.edit_actived ){
    //   this.msgError("Acesso negado.","Erro na Solicitação");
    //   this.router.navigate([`projetos/projeto/${this.idProjeto}/cadastro`]);
    // }
    if (this.cloneEntrega) {
      EventSharedService.get('reloadLayout').emit();
    }
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      description: new FormControl('', [Validators.required]),
      description_goal: new FormControl(""),
      agency_id: new FormControl(this.infoProjeto?.agency_id),
      level_mon_id: new FormControl(null),
      prod_id: new FormControl(null),
      dt_start: new FormControl(null, [Validators.required]),
      dt_foreseen_start: new FormControl({ value: null, disabled: true }),
      dt_conclusion: new FormControl(null, [Validators.required]),
      dt_foreseen_conclusion: new FormControl({ value: null, disabled: true }),
      bl_dt_foreseen_conclusion: new FormControl({ value: null, disabled: true }),
      manager: new FormControl(null),
      adjunct: new FormControl(null),
      pf_process_id: new FormControl(null),
      related_ind_id: new FormControl(null),
      related_ind_pf_id: new FormControl(this.idProjeto, [Validators.required]),
      irfe_id: new FormControl(null),
      ircp_id: new FormControl(null),
      extras: new FormArray([]),
    });

    if (!this.listOrgaos.find((item) => item.num_codigo_pk == this.entity?.agency_id || item.num_codigo_pk == this.infoProjeto?.agency_id)) {
      this.listOrgaos.push({ num_codigo_pk: this.infoProjeto?.agency_id, str_nome: this.infoProjeto?.agency_name });
      this.listOrgaos.sort((a, b) => a.str_nome.localeCompare(b.str_nome));
    }

    if (this.entity) {
      this.actionLabel = this.cloneEntrega ? 'Clone' : 'Editar';
      this.form.patchValue(this.entity);

      this.entity?.extras?.forEach((item) => {
        item.decimal_places = String(item?.decimal_places);
        this.getFormArray().push(this.createFormGroup(item))
      })

      if (this.entity?.dt_foreseen_start || this.entity?.dt_start) {
        this.form.get(
          this.entity?.dt_foreseen_start ? 'dt_foreseen_start' : 'dt_start'
        )?.disable();
      }

      if (this.entity?.dt_foreseen_conclusion || this.entity?.dt_conclusion) {
        this.form.get(
          this.entity?.dt_foreseen_conclusion ? 'dt_foreseen_conclusion' : 'dt_conclusion'
        )?.disable();
      }

      this.audit = {
        prt_issue_id: this.entity.id
      };
    }
    this.form.get('irfe_id')?.valueChanges.subscribe(valor => {
      if (valor) {
        this.setRequiredAgency(true);
      } else {
        this.setRequiredAgency(false);
      }
    });
  }

  createFormGroup(values = null): FormGroup {
    return new FormGroup({
      id: new FormControl(values?.id),
      title: new FormControl(values?.title, [Validators.required]),
      unit_id: new FormControl(values?.unit_id, [Validators.required]),
      decimal_places: new FormControl(values?.decimal_places, [Validators.required]),
      goal: new FormControl(values?.goal),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('extras') as FormArray;
  }

  addMedida() {
    this.getFormArray().push(this.createFormGroup());
  }

  removeMedida(index: number) {
    this.getFormArray().removeAt(index);
  }

  changeProjetoIndicador() {
    let projetoId = this.form.get('related_ind_pf_id')?.value;
    this.form.get('related_ind_id').setValue(null);
    if (projetoId) {
      this.loading();
      this.addSub(
        this.myService.getByIdListIndicador(projetoId).subscribe({
          next: (res) => {
            this.list.indicator = res;
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          }
        })
      )
    }
  }

  voltar() {
    if (this.entity?.id && !this.cloneEntrega) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'entregas', this.entity?.id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'entregas']);
    }
  }

  getDataCreate(): EntregaProjeto {
    let data: EntregaProjeto;
    data = Object.assign({}, data, this.form.value);

    data.pf_id = this.idProjeto;
    if (!this.entity?.id) {
      let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!formatoDataRegex.test(data.dt_start)) {
        data.dt_start = formatDate(data.dt_start, 'DD/MM/YYYY');
      }
      if (!formatoDataRegex.test(data.dt_conclusion)) {
        data.dt_conclusion = formatDate(data.dt_conclusion, 'DD/MM/YYYY');
      }
    }

    if (this.cloneEntrega) {
      data.id_clone = this.entity?.id;
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid && this.dataFormValid('dt_start', 'dt_conclusion')) {
      this.loading();
      if (this.entity?.id && !this.cloneEntrega) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Entrega alterada com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              // this.increaseEntregasItens();
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'entregas', res.id, 'editar']);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();

      this.getFormArray().controls.forEach((form, index) => {
        Object.keys(form['controls']).forEach((key) => this.getFormArray().controls[index]['controls'][key].markAsDirty())
      })
    }
  }

  // increaseEntregasItens() {
  //   this.infoProjeto.menu['entregas'].itens++;
  //   this.pesquisaGeralService.setInfoProject(this.infoProjeto);
  // }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index].get(field).invalid && this.getFormArray().controls[index].get(field).dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  formatarMedidaFisica(index: number) {
    let goalValue = this.getFormArray().controls[index].get('goal')?.value;
    let decimalPlacesValue = this.getFormArray().controls[index].get('decimal_places')?.value;
    let value = this.maskService.formatarMedidaFisica(goalValue, decimalPlacesValue);
    this.getFormArray().controls[index].get('goal').setValue(value);
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        // this.decreaseEntregasItens();
        this.loaded();
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'entregas']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error)
      }
    });
  }
  setRequiredAgency(value:boolean):void{
    const agencyField = this.form?.get('agency_id');
    if (agencyField) {
      if(value){
        agencyField.addValidators([Validators.required]);
      }
      else{
        agencyField.clearValidators();
      }
    }
  }
  // decreaseEntregasItens() {
  //   this.infoProjeto.menu['entregas'].itens--;
  //   this.pesquisaGeralService.setInfoProject(this.infoProjeto);
  // }
}
